import { last, findLastIndex, first } from 'lodash';
import {
  getWordByCoordinates,
  getWordIndexByCoordinates,
} from '../utils/functions';

let selecting = false;

// ***************************************************************************************
// onDoubleClick()
// Quand on double clique sur un mot, on le sélectionne
// ***************************************************************************************

export function onDoubleClick(event) {
  if (this.noCursor) {
    return;
  }

  this.wordsToSelect = [];

  const offsetX = event.nativeEvent.offsetX; // Position actuelle de la souris (X)
  const offsetY = event.nativeEvent.offsetY; // Position actuelle de la souris (Y)

  // On va prendre le mot la plus proche des coordonnées x et y
  // On ne prend pas le mot qui a déjà été validé
  let nextWord = getWordByCoordinates(this.script, offsetX, offsetY, false);
  if (!nextWord || nextWord.submitted) {
    return;
  }

  this.underSelection = true;
  this.wordsToSelect.push(nextWord);
  this.onRefreshCanvas(false);
}

// ***************************************************************************************
// onMouseDown()
// Quand on entre en action avec la souris
// ***************************************************************************************
let startMouseX = null;
let startMouseY = null;
let startWordIndex = -1;

export function onMouseDown(event) {
  if (!this.script || !this.script.length || this.noCursor) {
    return;
  }

  // si on a un mot vide, on le supprime et on refait l'action
  if (this.hasEmptyWord) {
    this.removeEmptyWord('onMouseDown').then(() => this.onMouseDown(event));
    return;
  }

  // A reactiver Si on a fini d'écrire, on lance la vérif
  if (this.typing) {
    // this.onCheckLineByWord(this.currentWord);
    this.typing = false;
  }

  if (this.scrolling) {
    this.scrolling = false;
  }

  if (this.state.search.showSelection) {
    this.setState({
      search: {
        ...this.state.search,
        showSelection: false,
      },
    });
  }

  const offsetX = event.nativeEvent.offsetX;
  const offsetY = event.nativeEvent.offsetY;

  startMouseX = offsetX;
  startMouseY = offsetY;

  if (!selecting && this.underSelection) {
    const index = getWordIndexByCoordinates(
      this.wordsToSelect,
      offsetX,
      offsetY
    );

    // Si je déplace les mots sélectionnés par la souris
    // pour info : on ne peut pas déplacer si le canvas est en mode readonly
    if (index !== -1 && !this.readonly) {
      this.moving = true;
      return;
    }

    this.underSelection = false;
    this.wordsToSelect = [];
    this.lettersToSelect = [];

    this.onRefreshCanvas(false);
  }

  // On va prendre le mot la plus proche des coordonnées x et y

  let nextWord = getWordByCoordinates(this.script, offsetX, offsetY);
  if (!nextWord) {
    return;
  }

  // On ne prend pas le mot qui a déjà été validé
  if (nextWord.submitted) {
    startMouseX = null;
    startMouseY = null;
    return;
  }

  if (!nextWord.letters.length) {
    this.currentWordIndex = nextWord.index;
    this.currentLineIndex = nextWord.indexLine;

    this.onMove();

    return;
  }

  // On va prendre la lettre la plus proche des coordonnées x
  let nextLetter = nextWord.letters.find(
    (letter) => letter.x <= offsetX && offsetX <= letter.x + letter.width
  );

  if (!nextLetter) {
    // sinon la dernière lettre du mot
    nextLetter = last(nextWord.letters);
  } else {
    // si le curseur se pointe vers la fin de la lettre, prendre la lettre suivante
    if (offsetX > nextLetter.x + nextLetter.width / 2) {
      nextLetter = nextWord.letters[nextLetter.index + 1];
    }

    if (!nextLetter) {
      // on prend le mot suivant
      nextWord = this.script[nextWord.index + 1];
      nextLetter = first(nextWord.letters);
    }
  }

  this.currentLetterIndex = nextLetter.indexLetter;
  this.currentWordIndex = nextWord.index;
  this.currentLineIndex = nextWord.indexLine;

  this.prevPositionsCursor.push({
    indexLetter: nextLetter.indexLetter,
    indexWord: nextWord.index,
    indexLine: nextWord.indexLine,
  });

  this.onMove();
}

let prevMouseX = null;
let prevMouseY = null;

// ***************************************************************************************
// onMouseMove()
// Quand la souris fait la sélection en pressant sur le bouton gauche
// ***************************************************************************************

export function onMouseMove(event) {
  if (!event.buttons || !this.script || !this.script.length || this.noCursor) {
    // on supprime le déplacement
    if (this.moving && this.underSelection) {
      this.onRemoveMoving();
    }

    return;
  }

  if (!startMouseX && !startMouseY) {
    return;
  }

  const offsetX = event.nativeEvent.offsetX; // Position actuelle de la souris (X)
  const offsetY = event.nativeEvent.offsetY; // Position actuelle de la souris (Y)

  // Définir la position du curseur pendant le déplacement
  if (this.moving) {
    const canvas = this.foreCanvas.current;
    if (canvas) {
      canvas.classList.add('moving');
    }

    const word = getWordByCoordinates(this.script, offsetX, offsetY);
    if (word) {
      const absStartX = Math.abs(word.startX - offsetX);
      const absEndX = Math.abs(word.endX - offsetX);

      if (absStartX < absEndX) {
        this.currentLetterIndex = first(word.letters).indexLetter;
      } else {
        this.currentLetterIndex = last(word.letters).indexLetter;
      }

      this.currentWordIndex = word.index;
      this.currentLineIndex = word.indexLine;
    }

    return;
  }

  if (!selecting) {
    const diffX = startMouseX - offsetX;
    const diffY = startMouseY - offsetY;
    // si c'est un léger mouvement, ne rien faire
    if (
      diffX >= -5 &&
      diffX <= 5 &&
      diffY >= -this.lineHeight &&
      diffY <= this.lineHeight
    ) {
      return;
    }

    selecting = true;
    this.underSelection = true;
    this.wordsToSelect = [];

    prevMouseX = null;
    prevMouseY = null;
  }

  if (offsetY <= 0 && this.scrollOffsetLine > 0) {
    this.scrollOffsetLine--;
    this.changeScrollValueState(this.scrollOffsetLine);

    this.onRefreshCanvas(false);
  } else {
    if (offsetY > this.height - 6) {
      this.scrollOffsetLine++;
      this.changeScrollValueState(this.scrollOffsetLine);

      this.onRefreshCanvas(false);
    }
  }

  // Quand on sélectionne le premier mot, déterminer le mot de départ vers le haut ou vers le bas
  if (
    (prevMouseX === null && prevMouseY === null) ||
    this.wordsToSelect.length === 0
  ) {
    startWordIndex = this.currentWordIndex;

    let currentWord = getWordByCoordinates(
      this.script,
      offsetX,
      offsetY,
      false
    );

    // Si la selection se fait hors champ
    if (!currentWord) {
      // si on sélectionne vers le bas
      if (startMouseY < offsetY) {
        // si le mot est le dernier de la ligne, prendre le mot suivant
        const lastLetter = this.currentWord.letters.find(
          (x) => x.indexLetter === this.currentLetterIndex
        );
        if (lastLetter && lastLetter.lastChar) {
          startWordIndex = startWordIndex + 1;
        }
      } else {
        // si on sélectionne vers le haut
        // si le mot est le premier de la ligne, prendre le mot précédent
        if (this.currentLetterIndex === 0) {
          startWordIndex = startWordIndex - 1;
        }
      }
    }
  }

  // si le mot a déjà été envoyé, on prend que le prochain mot non envoyé
  const startWord = this.script[startWordIndex];
  if (!startWord || startWord.submitted) {
    startWordIndex = this.script.findIndex((x) => !x.submitted);
  }

  let endIndex = getWordIndexByCoordinates(this.script, offsetX, offsetY);

  if (endIndex === -1) {
    endIndex = findLastIndex(
      this.script,
      (word) =>
        word.x !== 0 &&
        word.y !== 0 &&
        word.startY <= offsetY &&
        offsetY <= word.endY
    );
  }

  if (endIndex === -1) {
    prevMouseX = offsetX;
    prevMouseY = offsetY;
    return;
  }

  // si le mot a déjà été envoyé, on prend que le prochain mot non envoyé
  const endWord = this.script[endIndex];
  if (endWord.submitted) {
    endIndex = this.script.findIndex((x) => !x.submitted);
  }

  if (startWordIndex <= endIndex) {
    this.wordsToSelect = [...this.script.slice(startWordIndex, endIndex + 1)];
  } else {
    this.wordsToSelect = [...this.script.slice(endIndex, startWordIndex + 1)];
  }

  this.onRefreshCanvas(false);

  // Mettre à jour les coordonnées précédentes
  prevMouseX = offsetX;
  prevMouseY = offsetY;
}

// ***************************************************************************************
// onMouseUp()
// Quand on lâche la souris
// ***************************************************************************************
export function onMouseUp(event) {
  if (this.noCursor) {
    return;
  }

  // Si c'est en cours de déplacement, on arrête le déplacement
  if (this.moving && this.underSelection) {
    this.onRemoveMoving();

    const offsetX = event.nativeEvent.offsetX;
    const offsetY = event.nativeEvent.offsetY;

    const word = getWordByCoordinates(this.script, offsetX, offsetY, true);

    // Si le curseur est en dehors de la sélection, alors je déplace les mots
    if (!this.wordsToSelect.includes(word)) {
      this.onStopMoving();
      return;
    }

    // on positionne le curseur
    if (word) {
      // On va prendre la lettre la plus proche des coordonnées x
      let nextLetter = word.letters.find(
        (letter) => letter.x < offsetX && offsetX <= letter.x + letter.width
      );

      if (!nextLetter) {
        // sinon la dernière lettre du mot
        nextLetter = last(word.letters);
      } else {
        // si le curseur se pointe vers la fin de la lettre, prendre la lettre suivante
        if (offsetX > nextLetter.x + nextLetter.width / 2) {
          nextLetter = word.letters[nextLetter.index + 1];
        }
      }

      if (!nextLetter) {
        return;
      }

      this.currentLetterIndex = nextLetter.indexLetter;
      this.currentWordIndex = word.index;
      this.currentLineIndex = word.indexLine;

      this.prevPositionsCursor.push({
        indexLetter: nextLetter.indexLetter,
        indexWord: word.index,
        indexLine: word.indexLine,
      });
    }

    this.underSelection = false;

    this.wordsToSelect = [];
    this.onRefreshCanvas(false);
  }

  // Si je suis en train de sélectionner, j'arrête la sélection
  if (selecting) {
    selecting = false;
    prevMouseX = null;
    prevMouseY = null;
  }

  startMouseX = null;
  startMouseY = null;
}

// ***************************************************************************************
// onStopMoving()
// Quand on lâche la souris, j'arrête le déplacement des mots
// ***************************************************************************************
export function onStopMoving() {
  let deleteBefore = false; // Si le déplacement se fait en avant ou en arrière des mots sélectionnés
  let time = 0;

  let startIndexForUndo = 0;
  let endIndexForUndo = 0;

  if (first(this.wordsToSelect).index < this.currentWord.index) {
    startIndexForUndo = first(this.wordsToSelect).index;
    endIndexForUndo = this.currentWord.index;
    time = this.currentWord.endTime;
  } else {
    startIndexForUndo = this.currentWord.index;
    endIndexForUndo = last(this.wordsToSelect).index;
    deleteBefore = true;
    time = this.currentWord.startTime;
  }

  // Historiser l'action
  const nbWordsToUndoOrRedo = endIndexForUndo - startIndexForUndo;
  this.addNewActionForUndo(
    'OnMoving',
    startIndexForUndo,
    nbWordsToUndoOrRedo,
    nbWordsToUndoOrRedo
  );

  // Recalculer les timescode
  this.wordsToSelect.forEach((word) => {
    word.startTime = time;
    word.endTime = time;
  });

  // Je détermine le début de l'index pour l'action cut/paste
  let startIndex = 0;
  if (this.currentLetter.index === 0) {
    startIndex = this.currentWord.index;
  } else {
    startIndex = this.currentWord.index + 1;
  }

  // Cut/Paste
  if (deleteBefore) {
    this.script.splice(
      first(this.wordsToSelect).index,
      this.wordsToSelect.length
    );

    this.script.splice(startIndex, 0, ...this.wordsToSelect);
  } else {
    this.script.splice(startIndex, 0, ...this.wordsToSelect);

    this.script.splice(
      first(this.wordsToSelect).index,
      this.wordsToSelect.length
    );
  }

  // On redessine le canvas
  this.currentWordIndex = startIndex;
  this.forceRecalculateLines = true;

  this.onChange(this.currentWord.startTime, this.currentWord.index);
}

// ***************************************************************************************
// onRemoveMoving()
// On supprime le déplacement
// ***************************************************************************************
export function onRemoveMoving() {
  this.moving = false;

  const canvas = this.foreCanvas.current;
  if (canvas) {
    canvas.classList.remove('moving');
  }
}

// ***************************************************************************************
// onBlur()
// Quand le canvas perd le focus, on arrête l'action en cours
// ***************************************************************************************
export function onBlur() {
  // on supprime le déplacement
  if (this.moving && this.underSelection) {
    this.onRemoveMoving();
  }

  // on supprime le mot vide
  if (this.hasEmptyWord) {
    this.removeEmptyWord('onBlur');
  }
}

export function onClick(event) {
  if (this.readonly) {
    return;
  }

  if (this.state.speakerMenu.display) {
    this.onCloseSpeakerMenu();
    return;
  }

  if (this.state.contextMenu.display) {
    this.onCloseContextMenu();
    return;
  }

  const offsetX = event.nativeEvent.offsetX;
  let offsetY = event.nativeEvent.offsetY;

  // Si ca chevauche sur le mot
  if (this.currentWord && 
    Number.parseInt(this.currentWord.y) <= offsetY && 
    offsetY <= Number.parseInt(this.currentWord.y + (this.lineHeight / 2))) {
    return;
  }

  // Vérifier si on a cliqué sur un speaker
  if (this.speakerAreas && this.speakerAreas.length) {
    for (let speakerArea of this.speakerAreas) {
      if (
        offsetX >= speakerArea.x &&
        offsetX <= speakerArea.x + speakerArea.width &&
        offsetY >= speakerArea.y &&
        offsetY <= speakerArea.y + speakerArea.height
      ) {

        // + 2 car il y a aussi le titre et le champ rechercher
        const height = (this.props.speakers.length + 2) * 12;
        if (offsetY + height > this.height) {
          offsetY -= height;
        }

        if (offsetY < 0){
          offsetY = 0;
        }

        // Afficher le menu de sélection du speaker
        this.onShowSpeakerMenu(
          event.clientX,
          offsetY,
          speakerArea
        );

        speakerArea.callbackOpen();
        return;
      }
    }
  }
}
